import { CABA, CAPITAL } from "../../utils/constants";
import { Socio } from "../../models/socioPrincipal.model";
import { updateSocioPrincipal } from "../../api/socioPrincipalService";
import { YsocialActionType } from "../../interfaces/global-state/ysocial.action.type.enum";
import { Provincia } from "../../interfaces/provincia.interface";
import { getProvincias } from "../../api/direccionService";

/** Metodo que obtiene las provincias desde el servicio.
 *  En caso de fallar setea en true el reintentarError, en el caso de que sea un 200 se actualiza el context.
 */
export const obtenerProvinciasYsocial = async (
    apiRequest: (HttpRequestOptions) => Promise<any>,
    dispatch,
    setReintentarError,
    setLoadingProvinces
): Promise<Provincia[]> => {

    try {
        setLoadingProvinces(true);
        const provincias = await getProvincias(apiRequest)
        let index = provincias.findIndex(prov => prov.nombre.toUpperCase() == CAPITAL);
        provincias[index].nombre = CABA;

        dispatch({
            type: YsocialActionType.guardarProvincias,
            provincias
        })
        setReintentarError(false);
        setLoadingProvinces(false);
        return provincias

    } catch (error) {
        console.error('Fallo cargar provincias', error);
        dispatch({
            type: YsocialActionType.guardarProvincias,
            provincias: []
        })
        setLoadingProvinces(false);
        setReintentarError(true);
    }
}

export const updateDirection = (direcciones, socioPrincipal, apiRequest, dispatchYsocial) => {
    return new Promise((resolve, reject) => {
        let socio: Socio = socioPrincipal;
        let direccionesAux = direcciones.map((direc) => {
            if (direc.provincia === CABA) {
                return ({ ...direc, provincia: CAPITAL })
            }
            return direc;
        })

        socio.direcciones = direccionesAux;

        dispatchYsocial({
            type: YsocialActionType.actualizarDireccion,
            direcciones: direcciones
        })

        updateSocioPrincipal(socio, apiRequest).then((response) => {
            console.info('Se actualizo correctamente los datos del socio');
            resolve(response);
        }).catch(error => {
            console.error(`Hubo un error al persistir el socio principal ${error}`);
            reject(error);
        })
    })
}